<template>
  <svg fill="none" width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Group 15</title>
    <g id="EM" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Group-15" transform="translate(6.000000, 6.000000) scale(-1, 1) rotate(-90.000000) translate(-6.000000, -6.000000) " fill-rule="nonzero">
        <path d="M5.70710678,1.29289322 C6.09763107,1.68341751 6.09763107,2.31658249 5.70710678,2.70710678 L3.415,4.999 L11,5 C11.5522847,5 12,5.44771525 12,6 C12,6.55228475 11.5522847,7 11,7 L3.415,6.999 L5.70710678,9.29289322 C6.06759074,9.65337718 6.09532028,10.2206082 5.79029539,10.6128994 L5.70710678,10.7071068 C5.31658249,11.0976311 4.68341751,11.0976311 4.29289322,10.7071068 L0.292893219,6.70710678 C-0.0976310729,6.31658249 -0.0976310729,5.68341751 0.292893219,5.29289322 L4.29289322,1.29289322 C4.68341751,0.902368927 5.31658249,0.902368927 5.70710678,1.29289322 Z" id="Combined-Shape"></path>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'ArrowDownIcon'
  }
</script>

<style lang="scss" scoped>
	svg {
		fill: var(--color-primary);
	}
  g {
    fill: var(--color-primary);
  }
</style>